module.exports = __webpack_public_path__ + "img/1847.fe308727.gif";